import BigNumber from 'bignumber.js'

import { BigNumber as BigNumber_, Schema as Schema_ } from '@blade/std-lib'

import type { Equivalence } from '@blade/std-lib'
import type { InstantTradeBuyButtonDto } from '@root/shared/api/UserApi'

export const Schema = Schema_.Struct({
  key: Schema_.String,
  amount: BigNumber_.FromString,
})

export interface InstantTradeBuyButton
  extends Schema_.Schema.Type<typeof Schema> {}

export const fromDto = (
  dto: InstantTradeBuyButtonDto,
): InstantTradeBuyButton => {
  return {
    key: dto.key,
    amount: BigNumber(dto.amount),
  }
}

export const eq: Equivalence.Equivalence<InstantTradeBuyButton> = (a, b) => {
  return a.key === b.key && a.amount.eq(b.amount)
}
